<template>
  <div v-if="show" class="modal fade show d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,0.5); overflow-y: auto; z-index: 1050;">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content shadow">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold text-primary">
            Detalles del Antecedente: {{ antecedente.descripcion }}
          </h5>
          <button type="button" class="close" @click="close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" v-if="antecedente">
          <!-- Render dynamic details form based on tipoDetalle -->
          <ConditionDetail
            v-if="tipoDetalle === 'CONDITION'"
            v-model="form.detalles"
          />

          <FamilyHistoryDetail
            v-else-if="tipoDetalle === 'FAMILY_HISTORY'"
            v-model="form.detalles"
          />

          <AllergyDetail
            v-else-if="tipoDetalle === 'ALLERGY'"
            v-model="form.detalles"
          />

          <MedicationDetail
            v-else-if="tipoDetalle === 'MEDICATION'"
            v-model="form.detalles"
          />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-sm" @click="close">Cancelar</button>
          <button type="button" class="btn btn-success btn-sm" @click="save">Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConditionDetail from './ConditionDetail.vue';
import FamilyHistoryDetail from './FamilyHistoryDetail.vue';
import AllergyDetail from './AllergyDetail.vue';
import MedicationDetail from './MedicationDetail.vue';

export default {
  name: 'AntecedenteDetalleModal',
  components: {
    ConditionDetail,
    FamilyHistoryDetail,
    AllergyDetail,
    MedicationDetail
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    antecedente: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        detalles: []
      }
    };
  },
  computed: {
    tipoDetalle() {
      if (!this.antecedente) return null;
      const config = this.antecedente.rda_configs && this.antecedente.rda_configs[0];
      return config ? config.tipo_detalle : null;
    }
  },
  watch: {
    show(val) {
      if (val && this.antecedente) {
        // Inicializar form con datos de antecedente.antecedente_usuario
        const antUser = this.antecedente.antecedente_usuario || {};
        this.form = {
          detalles: Array.isArray(antUser.detalles) ? [...antUser.detalles] : []
        };
      }
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    save() {
      this.$emit('save', {
        detalles: this.form.detalles
      });
    }
  }
};
</script>
